// for add employee
export const RESET_ADD_EMPLOYEE_EXPERIENCE = "reset_add_employee_experience";
export const ADD_EMPLOYEE_EXPERIENCE = "add_employee_experience";
export const ADD_EMPLOYEE_EXPERIENCE_SUCCESS = "add_employee_experience_success";
export const ADD_EMPLOYEE_EXPERIENCE_FAILURE = "add_employee_experience_failure";
